import React from 'react';
import { CapabilitiesPage } from './CapabilitiesPage';
import { StandardQuestionsPage } from './StandardQuestionsPage';
import PageHeader from './PageHeader';
import { shouldRenderPageHeader } from 'js/engines/CapabilitiesAssessment/utils';

function Page({ page }) {
  const header = shouldRenderPageHeader(page) ? (
    <PageHeader page={page} />
  ) : null;

  switch (page.type) {
    case 'standard-questions':
      return <StandardQuestionsPage page={page} header={header} />;
    default:
      return <CapabilitiesPage page={page} header={header} />;
  }
}

export default Page;
